import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "../slice/authSlice";
import productReducer from "../slice/productSlice";
import filterReducer from "../slice/filterSlice";
import cartReducer from "../slice/cartslice";
import checkoutReducer from "../slice/checkoutslice";
import orderReducer from "../slice/orderSlice";



const rootReducer = combineReducers({
  auth: authReducer,
  product: productReducer,
  filter: filterReducer,
  cart: cartReducer,
  checkout:checkoutReducer,
  orders:orderReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
